<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="模式名称" class='tiny' cleartable>
						<el-input style="width: 200px;" v-model="searchInfo.bmTitle" placeholder="请输入模式名称"></el-input>
					</el-form-item>
					
					
					<el-form-item label="审核状态" class='tiny' cleartable>
						<el-select v-model="searchInfo.status" placeholder="请选择">
							<el-option key="-1" label="全部" value="">全部</el-option>

							<el-option key="0" label="待审核" :value="0">待审核</el-option>
							<el-option key="1" label="已通过" :value="1">已通过</el-option>
							<el-option key="2" label="已驳回" :value="2">已驳回</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="选择分类" >
						<el-select v-model="searchInfo.useArea" filterable class="big" placeholder="请选择"
							@change="getStoreName">
							<el-option key="-1" label="全部" value="">全部</el-option>

							<el-option v-for="item in classGoods1List" :key="item.id" :value="item.classifyName"
								:label="item.classifyName">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item >
					<template>
						<el-button type="primary" @click="search">查询</el-button>
						<el-button @click="empty">清空</el-button>
						<el-button type="primary" @click="dialogVisibleFun()">新增模式</el-button>
						<!-- <el-button type="primary" @click="downloadFile"> 导出 </el-button> -->
					</template>
					</el-form-item>
				</el-form>
			</header>
		</div>
		<el-table :data="goodsList.list" stripe style="width: 100%;" :header-cell-style="headClass" v-loading="loading"
			element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
			<el-table-column type="expand">
				<template slot-scope="props">
					<el-form label-position="left" inline class="demo-table-expand" label-width="140px">
						<el-form-item label="模式名称">
							<span>{{ props.row.bmTitle }}</span>
						</el-form-item>
						<el-form-item label="适用范围" >
							<span>{{ props.row.useArea?props.row.useArea:'无' }}</span>
						</el-form-item>
						<el-form-item label="模式介绍">
							<el-button size="small" type="text" @click="findDetail(props.row.introduction,1)">点击查看</el-button>
						</el-form-item>

						<el-form-item label="摘要说明">
							<span>￥{{ props.row.remark }}</span>
						</el-form-item>
						<el-form-item  label="状态">
							<span v-if="props.row.status==0">待审核</span>
							<span v-if="props.row.status==1">已通过</span>
							<span v-if="props.row.status==2">已驳回</span>
						</el-form-item>
						<el-form-item label="驳回原因" v-if="props.row.status==2">
							<el-button size="small" type="text" @click="findDetail(props.row.rejectReason,1)">点击查看</el-button>
						</el-form-item>
						
						<el-form-item label="审核时间">
							<span>{{ props.row.checkTime }}</span>
						</el-form-item>
						<el-form-item label="审核人">
							<span>{{ props.row.checkBy }}</span>
						</el-form-item>

						<el-form-item label="阅读次数">
							<span>{{ props.row.readtimes?props.row.readtimes:'无' }}</span>
						</el-form-item>
						<el-form-item label="点赞次数">
							<span>{{ props.row.liketimes?props.row.liketimes:'无' }}</span>
						</el-form-item>
						<el-form-item label="回复次数">
							<span>{{ props.row.replytimes?props.row.replytimes:'无' }}</span>
						</el-form-item>
						<el-form-item label="分享转发次数">
							<span>{{ props.row.sharetimes?props.row.sharetimes:'无' }}</span>
						</el-form-item>
						<el-form-item label="是否热门">
							<span>{{ props.row.isHot?'是':'否' }}</span>
						</el-form-item>
						<el-form-item label="置顶">
							<p v-if="props.row.topType==2">全局置顶</p>
							<p v-if="props.row.topType==1">本分类置顶</p>
							<p v-if="props.row.topType==0">否</p>
						</el-form-item>
						
						<el-form-item label="最后一次编辑人" >
							<span>{{ props.row.editUid }}</span>
						</el-form-item>
						<el-form-item label="最后一次编辑时间" >
							<span>{{ props.row.editDatetime }}</span>
						</el-form-item>
						<el-form-item label="更新时间" >
							<span>{{ props.row.updateTime }}</span>
						</el-form-item>
					</el-form>
				</template>
			</el-table-column>
		
			
			<el-table-column prop="bmTitle" label="模式名称" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="useArea" label="适用范围" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<span>{{ scope.row.useArea?scope.row.useArea:'无' }}</span>
				</template>
			</el-table-column>
			<el-table-column prop="readtimes" label="阅读次数" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<span>{{ scope.row.readtimes?scope.row.readtimes:'无' }}</span>
				</template>
			</el-table-column>
			<el-table-column prop="readtimes" label="是否热门" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<span>{{ scope.row.isHot?'是':'否' }}</span>
				</template>
			</el-table-column>
			<el-table-column label="置顶" prop="topType" align="center" :show-overflow-tooltip="true" >
				<template slot-scope="scope">
					<p v-if="scope.row.topType==2">全局置顶</p>
					<p v-if="scope.row.topType==1">本分类置顶</p>
					<p v-if="scope.row.topType==0">否</p>
				</template>
			</el-table-column>
			<el-table-column prop="status" label="审核状态" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<p v-if="scope.row.status==2">已驳回</p>
					<p v-if="scope.row.status==1">已通过</p>
					<p v-if="scope.row.status==0">待审核</p>
				</template>
			</el-table-column>
			<el-table-column prop="createUserName" label="创建人" width="100px" align="center"
				:show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="createTime" label="创建时间"  sortable align="center"
				:show-overflow-tooltip="true">
			</el-table-column>
			
			<el-table-column  label="操作"  fixed="right" align="center" width="150px" >
				<template slot-scope="scope">
					<el-button size="small" type="text" @click="dialogVisibleFun(scope.row.id)">编辑</el-button>　　
					<el-dropdown trigger="click" style="margin-left: 10px;">
						<el-button type="text" size="small">更多</el-button>
						<el-icon class="el-icon-caret-bottom"></el-icon>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item @click.native="editialogVisible(scope.row.id)"
								v-if=" scope.row.status==0">审核</el-dropdown-item>
								<el-dropdown-item @click.native="bohui(scope.row.id)"
									v-if=" scope.row.status==0">驳回</el-dropdown-item>
								
							
							<el-dropdown-item @click.native="toDelete(scope.row)">删除</el-dropdown-item>

							<!-- <el-dropdown-item @click.native="auditClick(scope.row)">审核记录</el-dropdown-item> -->
						</el-dropdown-menu>
					</el-dropdown>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination style="margin: 20px 0px 20px;" background :current-page="goodsList.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper" :total="goodsList.total"
			@size-change="handleSizeChange">
		</el-pagination>
		<!-- 详情查看 -->
		<el-dialog style="float:rigin" title="详情查看" :closeOnClickModal="false" :visible.sync="dialogVisibleDetails"
			width="50%">
			<div class="detailImg" v-if="detailType == 1" v-html="detail"></div>
			<div v-if="detailType == 2"
				style="display: flex;align-items: center;justify-content: space-between;flex-wrap: wrap;">
				<img style="width:40%;margin: 20px;" :src="image" v-for="(image,index) in  images" :key="index" />
			</div>
			<div style="text-align: center;">
				<el-button type="primary" @click="dialogVisibleDetails = false">关 闭</el-button>
			</div>
		</el-dialog>
		<!-- 编辑商家 -->
		<el-dialog style="float:rigin" :title="dialogVisibleFunName" :closeOnClickModal="false"
			:visible.sync="dialogVisible" width="60%">
			<div class="app-container" style="text-align: center;">
				<el-form size="medium">
					<div style="">
						<div style="text-align: left;">
						</div>
					
					
						<div style="display: flex;align-items: center;justify-content: flex-start;"
							>
							<el-form-item label="模式名称" style="width: 40%;">
								<el-input type="text" clearable v-model="storeGoodsInfo.bmTitle" placeholder="请输入模式名称" />
							</el-form-item>
							
							<el-form-item label="选择分类"  style="margin-left: 40px;">
								<el-select v-model="storeGoodsInfo.useArea" filterable class="big" placeholder="请选择"
									@change="getStoreName">
									<el-option v-for="item in classGoods1List" :key="item.id" :value="item.classifyName"
										:label="item.classifyName">
									</el-option>
								</el-select>
							</el-form-item>
							
						</div>
						<el-form-item label="模式LOGO">
							<!-- 图片上传 -->
							<el-upload class="avatar-uploader" :action="httpUrl" :on-preview="handlePreview"
								:before-upload="beforeAvatarUpload" :on-success="onSuccess" :show-file-list="false">
								<img style="width: 100px;height: 100px;" v-if="hylogo" :src="hylogo"
									class="avatar">
								<i v-else class="el-icon-plus avatar-uploader-icon"></i>
							</el-upload>
						</el-form-item>
					</div>
					<div style="display: flex;">
						<el-form-item label="是否置顶" class="redItem" style="flex: 25%;">
							<el-select v-model="storeGoodsInfo.topType" filterable class="big" placeholder="请选择"
								>
								<el-option value="0" label="不置顶"></el-option>
								<el-option value="1" label="本分类置顶"></el-option>
								<el-option value="2" label="全局置顶"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="是否热门" class="redItem" style="flex: 25%;">
							<el-switch v-model="storeGoodsInfo.isHot" :active-value="true" :inactive-value="false">
							</el-switch>
						</el-form-item>
					</div>
					<el-form-item label="摘要说明" style="width: 50%;">
						<el-input   type="textarea" clearable v-model="storeGoodsInfo.remark" placeholder="请输入摘要说明" />
					</el-form-item>
					
				
					<el-form-item label="其他说明" style="width: 40%;">
						<el-input type="textarea" clearable v-model="storeGoodsInfo.memo" placeholder="请输入其他说明" />
					</el-form-item>
					
					<div style="width: 100%;">
						<div style="text-align: start;margin: 10px;">介绍</div>
						<el-form-item style="width: 100%;">
							<div id="lpc-quill" class="quill" style="width: 100%;">
								<el-upload class="upload-demo" v-show="false" ref="upload" :action="httpUrl"
									:before-upload="beforeAvatarUpload" :on-success="upScuccess"
									:on-error="uploadError" />
								<quill-editor v-model="storeGoodsInfo.introduction" ref="myQuillEditor" 
								class="editer"
									:options="editorOption" @ready="onEditorReady($event)">
								</quill-editor>
							</div>
						</el-form-item>
					</div>
				</el-form>
			</div>
			<div style="text-align: center;">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button v-if="dialogVisibleFunName == '新增模式'" type="primary" @click="add" :loading="addLoading">添 加</el-button>
				<el-button v-if="dialogVisibleFunName == '编辑模式'" type="primary" @click="sure" :loading="sureLoading">编 辑</el-button>
			</div>
		</el-dialog>
		<el-dialog :visible.sync="dialogVisibleImg" :closeOnClickModal="false">
			<div style="text-align: center;">
				<img width="100%" class="el-upload-list__item-thumbnail" :src="dialogImageUrl" alt="">
			</div>
			<div style="text-align: center;">
				<el-button type="primary" @click="dialogVisibleImg = false">关 闭</el-button>
			</div>
		</el-dialog>
		<el-dialog style="float:rigin" title="审核驳回" :closeOnClickModal="false" :visible.sync="editDialogVisible1"
			width="50%">
			<div style="display: flex;align-items: center;justify-content: space-between;">
				<el-form>
					<el-form-item label="驳回原因:" class="redItem" style="width: 100%;">
						<el-input style="width: 100%;" v-model="rejectReason" placeholder="请输入驳回原因">
						</el-input>
					</el-form-item>
				</el-form>
			</div>
			<div style="text-align: center;">
				<el-button @click="editDialogVisible1=false;loading=false">取 消</el-button>
				<el-button @click="shenhe()" :loading="loading2" type="primary">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		uploadFileServer
	} from "@/api/axios.js";
	var urls = uploadFileServer('business');

	import {
		quillEditor
	} from "vue-quill-editor"; //调用编辑器
	import "quill/dist/quill.core.css";
	import "quill/dist/quill.snow.css";
	import "quill/dist/quill.bubble.css";

	Array.prototype.remove = function(val) {
		var index = this.indexOf(val);
		if (index > -1) {
			this.splice(index, 1);
		}
	};

	export default {
		components: {
			//使用编辑器
			quillEditor
		},
		data() {
			return {
				rejectReason:'',
				buy: {
					goodId: null,
					ids:'',
					goodsName: null,
					price: null,
					num: null,
					storeId: null,
					status: null,
					goodsImages: ""
				},
				auditDialogVisibleInfo:false,
				auditTitle: '',
				reason: '',
				topType:'',
				stoId: '',
				editDialogVisible1: false,
				setUpBuyVisible: false,
				goodsImages: [],
				userList: [],
				fileList: [],
				fileList1: [],
				dialogVisibleImg: false,
				dialogImageUrl: '',
				httpUrl: urls,
				loading: false,
				loading2: false,
				goodsList: [{}], //列表
				dialogVisible: false,
				editDialogVisible: false,
				dialogVisibleFunName: '',
				accountList: [],
				dialogVisibleDetails: false,
				detail: '',
				images: [],
				detailType: 0,
				classGoods1List: [],

				classGoods1Id: "",
	
				classGoods1Id1: "",
		
				storeGoodsInfo: {
					
					
				},
				storeGoodsInfo1: {
					
				},
				provinceList: {},
				cityList: {},
				districtList: {},
				storeGoodsId: '', //授权用户id
				storeList: [],
				form: {
					refuseReason: ""
				},
				mainFormRules: {
					refuseReason: {
						required: true,
						message: "请输入驳回原因",
						trigger: "blur"
					},
				},
				page: {
					pageNum: 1,
					pageSize: 10
				},
				useArea:'',
			
				isSearchShow: false,

				storeNameId: '', //店铺iD
				supplierId: '', // 供应商id 
				supplierId2: '', // 供应商id 
				searchInfo: {
					status: '',
					useArea: '',
				},
				hylogo:'',
				editorOption: {
					// 富文本编辑器配置
					placeholder: "请输入内容",
					modules: {
						toolbar: {
							container: [
								["bold", "italic", "underline", "strike"], // 加粗，斜体，下划线，删除线
								[{
										header: 1,
									},
									{
										header: 2,
									},
								], // 标题，键值对的形式；1、2表示字体大小
								[{
										list: "ordered",
									},
									{
										list: "bullet",
									},
								], // 列表
								[{
										script: "sub",
									},
									{
										script: "super",
									},
								], // 上下标
								[{
										indent: "-1",
									},
									{
										indent: "+1",
									},
								], // 缩进
								[{
									direction: "rtl",
								}, ], // 文本方向
								[{
									size: ["small", false, "large", "huge"],
								}, ], // 字体大小
								[{
										color: [],
									},
									{
										background: [],
									},
								], // 字体颜色，字体背景颜色
								[{
									align: [],
								}, ], // 对齐方式
								["clean"], // 清除字体样式
								["image"], // 上传图片、上传视频
							],
							handlers: {
								image: function(value) {
									// console.log(value)
									if (value) {
										document
											.querySelector("#lpc-quill .upload-demo input")
											.click();
									} else {
										this.quill.format("image", false);
									}
								},
							},

						},
					},
					theme: "snow",
				},
				auditFlag:false, //审核记录弹窗
				auditLogging:{}, //审核记录
				auditPage: {
					pageNum: 1,
					pageSize: 6,
					id : 122
				},
				auditLoading:false,

				addLoading : false,
				sureLoading: false,
			};
		},

		computed: {
			pv() {
				return (this.storeGoodsInfo.costPrice / this.storeGoodsInfo.price).toFixed(4)
			},
			pv1() {
				return (this.storeGoodsInfo1.costPrice / this.storeGoodsInfo1.price).toFixed(4)
			},
			intermediatorNum() {
				return (this.storeGoodsInfo.intermediatorRate * this.storeGoodsInfo.price).toFixed(2)
			},
			intermediatorNum1() {
				return (this.storeGoodsInfo1.intermediatorRate * this.storeGoodsInfo1.price).toFixed(2)
			}
		},
		methods: {
			bohui(id) {
				this.ids=id
				this.editDialogVisible1 = true
			},
			tonguo() {

			},
			//导出
			downloadFile() {
				let data = {
					goodsCode: this.searchInfo.goodsCode ? this.searchInfo.goodsCode : "",
					status: this.searchInfo.status ? this.searchInfo.status : "",
					orderType: this.searchInfo.orderType ? this.searchInfo.orderType : "",
					goodsName: this.searchInfo.goodsName ? this.searchInfo.goodsName : "",
					isDh: this.searchInfo.isDh ? this.searchInfo.isDh : "",
					// startTime: this.searchInfo.timer ? this.searchInfo.timer[0] : "",
					// cutOffTime: this.searchInfo.timer ? this.searchInfo.timer[1] : "",
				};
				//   console.log(data);
				this.$api.commodityExcel(data).then((res) => {
					// console.log(res.data);
					this.showloadFile(res.data);
				});
			},
			showloadFile(res) {
				if (!res) {
					return;
				}
				const link = document.createElement("a");
				let blob = new Blob([res], {
					type: "application/vnd.ms-excel",
				});
				link.style.display = "none";
				link.href = URL.createObjectURL(blob);
				link.setAttribute("download", "商品管理" + ".xls");
				document.body.appendChild(link);
				link.click();
				URL.revokeObjectURL(link.href); // 释放URL 对象
				document.body.removeChild(link);
			},
			selectisCrontab(e) {
				if (this.storeGoodsInfo.isDh == true) {
					e = false
					this.storeGoodsInfo.isCrontab = false

				} else {
					this.storeGoodsInfo.isCrontab = e

				}
				this.$forceUpdate()
			},
			selectisChoiceness(e) {
				if (this.storeGoodsInfo.isDh == true) {
					e = false
					this.storeGoodsInfo.isChoiceness = false

				} else {
					this.storeGoodsInfo.isChoiceness = e

				}
				this.$forceUpdate()
			},
			handleIsDh(e) {
				if (e == true) {
					this.storeGoodsInfo.isCrontab = false
					this.storeGoodsInfo.isChoiceness = false
				}
			},
			getUserList(e) {
				// console.log('输入的用户明--',e);
				this.$api.getUserList(this.$encrypt({
					username: e
				})).then((res) => { //角色管理列表
					// console.log('角色管理列表:', res);
					res = JSON.parse(this.$decrypt(res.data))
					if (res.state == 'success') {
						this.userList = res.data
						// console.log(res);
						this.loading = false
					}

				})
			},
			onSuccess(response, file, fileList) {
				// console.log(res)
				
				this.hylogo = response.message;
				// console.log("asda",response,this.goodsImages)
			},
			handleRemove(file, fileList) {
				if (file.response) {
					this.goodsImages.remove(file.response.message);
				}
				this.goodsImages.remove(file.url);
			},
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisibleImg = true;
			},
			
			findDetail(string, type) {
				this.dialogVisibleDetails = true;
				this.detailType = type;
				if (type == 1) {
					this.detail = string;

				}
				if (type == 2) {
					this.images = string.split(",");
				}
			},
			storeGoodsHitTheShelfOrSoldOut(id) {
				this.$api.storeGoodsHitTheShelfOrSoldOut(id).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.editDialogVisible = false
						this.getStoreGoodsList()
					} else {
						this.$message.error(res.message);
					}
				})
			},
			empty() {
				this.searchInfo = {}
			},
			search() {
				this.page.pageNum = 1;
				this.getStoreGoodsList()
			},
			//店铺审核
			editgoodsInfoCheck(authStatus) {
				if (authStatus == 2) {
					//通过驳回
					this.loading2 = true
					var data = {
						id:this.ids,
						status: authStatus,
						remark: this.reason
					}
				} else {
					this.loading = true
					//通过审核
					var data = {
						id: this.ids,
						status: authStatus
					}
				}
				this.$api.storeGoodsReview(this.$encrypt(data)).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.editDialogVisible = false
						this.editDialogVisible1 = false
						this.reason = ''
						this.loading2 = false
						this.loading = false
						this.getStoreGoodsList()
					} else {
						this.loading = false
						this.loading2 = false
						this.$message.error(res.message);
					}
				})

			},

			//审核驳回弹窗关闭
			cannelPass() {
				this.editDialogVisible = false
			},
			shenhe(){
				this.$api.auditById({id:this.ids,status:2,rejectReason:this.rejectReason}).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.getStoreGoodsList();
						this.editDialogVisible1 = false
					} else {
						this.$message.error(res.message);
					}
				})
			},
			//审核驳回弹窗打开
			editialogVisible(id) {
				var str = "此操作将审核通过该模式, 是否继续?"
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.auditById({id:id,status:1}).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.getStoreGoodsList();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
		
				
				
			},
			// 店铺编辑弹窗
			dialogVisibleFun(id) {
				this.storeInfo = {}
				this.storeGoodsInfo={}
				this.dialogVisibleFunName = "新增模式"
				this.dialogVisible = true;
				this.hylogo = ''
				
				
				if (id) {
					this.dialogVisibleFunName = "编辑模式"
					this.storeGoodsId = id
					this.$api.findAllclassid(this.storeGoodsId).then((res) => {
						
						if (res.state == 'success') {
							this.storeGoodsInfo = res.data
							this.storeGoodsInfo.topType=res.data.topTypeName
							this.useArea=res.data.useArea
							this.hylogo=res.data.logo
							// console.log(this.classGoods1List);
						}
					})
				}
			},
			//添加商品
			add() {
			
				this.addLoading = true;
				this.$api.addfAllms({
					...this.storeGoodsInfo,
					useArea: this.useArea,
					logo:this.hylogo
					
				}).then((res) => {

					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.dialogVisible = false;
						this.searchInfo = {}
						this.storeGoodsInfo={}
						this.getStoreGoodsList();
					} else {
						this.$message.error(res.message);
					}
					this.addLoading = false;
				})
			},
			//编辑商品
			sure() {
				
				this.sureLoading = true;
				this.$api.editById({
					...this.storeGoodsInfo,
					topType:this.storeGoodsInfo.topType=='不置顶'?0:
					this.storeGoodsInfo.topType=='本分类置顶'?1:this.storeGoodsInfo.topType=='全局置顶'?2:this.storeGoodsInfo.topType,
					id:this.storeGoodsId,
					logo:this.hylogo
				}).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.dialogVisible = false;
						this.searchInfo = {}
						this.storeGoodsInfo={}
						this.getStoreGoodsList();
					} else {
						this.$message.error(res.message);
					}
					this.sureLoading = false;
				})

			},
			//删除
			toDelete(row) {
				/* if (row.status == 0) {
					var str = "此操作将启用该店铺账号, 是否继续?"
				} else {
					var str = "此操作将禁用该店铺账号, 是否继续?"
				} */
				var str = "此操作将删除该模式, 是否继续?"
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.deleteById(row.id).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.getStoreGoodsList();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			},
			headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
			},
			pageChange(data) {
				this.page.pageNum = data
				this.getStoreGoodsList()
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.getStoreGoodsList()
			},
			auditPageChange(data) { //审核记录
				this.auditPage.pageNum = data
				this.getAuditLogging()
			},
			auditHandleSizeChange(val) { //审核记录
				this.auditPage.pageSize = val
				this.getAuditLogging()
			},
			getAuditLogging(){ //查询审核记录
				
				this.$api.findshenhgoods(this.auditPage).then((res) => { //商品列表
					
					// console.log(res);
					if (res.state == 'success') {
						this.auditLogging = res.data
						this.auditLoading = false
					}
				})
			},
			auditClick(item){
				// console.log('商品审核回显--',item)
				this.auditPage.goodsId = item.id
				this.getAuditLogging()
				this.auditFlag = true;
			},
			getStoreGoodsList() {
				this.loading = true
				this.searchInfo.pageNum = this.page.pageNum;
				this.searchInfo.pageSize = this.page.pageSize;
				this.$api.findAllms(this.searchInfo).then((res) => { //商品列表
			
					// console.log(res);
					if (res.state == 'success') {
						this.goodsList = res.data
						this.loading = false
					}else{
						this.$message.error(res.message);
					}
				})
			},
			changeNull(row, column, cellValue) {
				if (cellValue) {
					return cellValue;
				} else if (cellValue == 0) {
					return "0";
				} else {
					return "暂无";
				}
			},
			getStoreAndUser(e) {
				// console.log(e);
				this.supplierId2 = e
				let obj = {};
				obj = this.accountList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});

				// this.supplierId = obj.supplierName;
				// console.log(this.supplierId);
				this.storeGoodsInfo.supplierName = obj.supplierName;
				// this.storeGoodsInfo.address = obj.address;
				// this.storeGoodsInfo.phone = obj.phone;
				// this.$forceUpdate()
				// console.log(this.storeGoodsInfo.username,this.storeGoodsInfo.storeName,this.storeGoodsInfo.userId)
			},
			getStoreAndUser1(e) {

				// console.log('---', e);
				let obj = {};
				obj = this.storeList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				// this.storeGoodsInfo.supplierId = obj.supplierId;
				this.storeGoodsInfo.userId = obj.userId;
				this.$forceUpdate()
				// console.log(this.storeGoodsInfo.username,this.storeGoodsInfo.storeName,this.storeGoodsInfo.userId)
			},
		
			//上传店铺logo
			upLoadLogo(param) {
				const formData = new FormData()
				formData.append('file', param.file)
				this.$api.uploadFile(formData, "goods").then((res) => {
					// console.log('列表:', res);
					this.storeInfo.storeLogo = res.message
				})
			},
			// 上传身份证正面图片
			upLoadLegalIdFace(param) {
				const formData = new FormData()
				formData.append('file', param.file)
				this.$api.uploadFile(formData, "goods").then((res) => {
					// console.log('列表:', res);
					this.storeInfo.legalIdFace = res.message
				})
			},
			// 上传身份证反面图片
			upLoadLegalIdBack(param) {
				const formData = new FormData()
				formData.append('file', param.file)
				this.$api.uploadFile(formData, "goods").then((res) => {
					// console.log('列表:', res);
					this.storeInfo.legalIdBack = res.message
				})
			},

			// 点击文件触发
			handlePreview(file) {
				// console.log(file)
			},
			// 上传图片前，筛选
			beforeAvatarUpload(file) {
				// console.log(file)1048576
				const isLt2M = file.size / 1024 / 1024 < 8;
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 8MB!');
					return false;
				}
				var imgStr = /\.(jpg|jpeg|png|bmp|BMP|JPG|PNG|JPEG)$/;
				if (!imgStr.test(file.name)) {
					this.$message.error("文件不是图片类型，请上传正确格式图片！");
					return false;
				}
				return isLt2M, imgStr;
			},
			upScuccess(res, file) {
				const quill = this.$refs.myQuillEditor.quill;
				if (res.state == "success" && res.message !== null) {
					const length = quill.getSelection().index; // 获取光标所在位置
					quill.insertEmbed(length, "image", res.message); // 插入图片
					quill.setSelection(length + 1); // 调整光标位置到最后
				} else {
					this.$message.error("图片上传失败");
				}
			},
			uploadError() {
				this.$message.error("图片上传失败");
			},
			inputHandler() {
				this.isSearchShow = true
				if (this.storeGoodsInfo.joint === '') {
					this.isSearchShow = false
				}

				this.getUserList(this.storeGoodsInfo.joint)
			},
			onEditorReady(editor) {
				// 准备编辑器
				// console.log(editor);
			},
			
			getStoreName(e) {
				
				this.useArea=e
			},
			
		
			preAudit(e){// 审核前
				// console.log(JSON.parse(e))
				this.auditTitle = '审核前'
				this.auditDialogVisibleInfo = true;
				this.storeGoodsInfo = JSON.parse(e)
				this.storeGoodsInfo.images = this.storeGoodsInfo.images.split(',')
			},
			afterAudit(e){// 审核后
				// console.log(JSON.parse(e))
				this.auditTitle = '审核后'
				this.auditDialogVisibleInfo = true;
				this.storeGoodsInfo = JSON.parse(e)
				this.storeGoodsInfo.images = this.storeGoodsInfo.images.split(',')
				// console.log(this.storeGoodsInfo)
			},
			classGoods1(){
				
			},
		},
		created() {
		
			this.$api.findAllclass().then(res => { //商品一级分类
				// console.log(res);
				if (res.state == 'success') {
					this.classGoods1List = res.data;
				}
			})
		
			this.getStoreGoodsList();
		
			
		}

	};
</script>

<style scoped lang="less">
	.demo-table-expand {
		font-size: 0;
		margin-left: 120px;
	}

	.demo-table-expand label {
		width: 100px;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		width: 100px;
		height: 100px;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}


	.avatar-uploader1 .el-upload {
		border: 1px dashed #d9d9d9;
		width: 200px;
		height: 100px;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 100px;
		height: 100px;
		line-height: 100px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}

	.detailImg img {
		width: 100%;
	}

	.redItem {
		display: flex;
		flex-direction: row;
		align-items: center;
	}

	/deep/.el-input__inner {
		color: black !important;
	}

	/deep/.el-textarea__inner {
		color: black !important;
	}

	/deep/ .ql-toolbar {
		width: 100%;
		text-align: left;
	}

	/deep/.ql-editor {
		height: 648px;
	}
</style>